import React, { useState } from 'react';
import { makeStyles } from '@fluentui/react-components';
import { CalendarLtr20Regular } from '@fluentui/react-icons';
import { DateQuestion as DateQuestionType } from '../../../../types/forms';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
    alignItems: 'flex-start',
  },
  questionTitle: {
    fontFamily: '"Segoe UI", sans-serif',
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: '28px',
    color: '#242424',
    marginBottom: '12px',
  },
  dateInputWrapper: {
    position: 'relative',
    width: 'calc(100% - 30px)',
    marginLeft: '20px',
  },
  dateInput: {
    width: '100%',
    minHeight: '32px',
    padding: '5px 40px 5px 8px',
    border: '1px solid #d1d1d1',
    borderRadius: '4px',
    backgroundColor: '#fafafa',
    fontFamily: '"Segoe UI", sans-serif',
    fontSize: '14px',
    color: '#242424',
    outline: 'none',
    '&::placeholder': {
      color: '#a8a8a8',
    },
  },
  calendarIcon: {
    position: 'absolute',
    right: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#616161',
    pointerEvents: 'none',
  },
});

interface DateQuestionViewProps {
  question: DateQuestionType;
  questionNumber: number;
  onClick?: () => void;
}

export const DateQuestionView: React.FC<DateQuestionViewProps> = ({
  question,
  questionNumber,
  onClick,
}) => {
  const styles = useStyles();
  const [dateValue, setDateValue] = useState('');

  return (
    <div className={styles.container} onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }} data-question-view>
      <div className={styles.questionTitle}>
        {questionNumber}. {question.title}
        {question.required && <span style={{ color: '#d13438', marginLeft: '4px' }}>*</span>}
      </div>
      
      <div className={styles.dateInputWrapper}>
        <input
          type="text"
          className={styles.dateInput}
          value={dateValue}
          onChange={(e) => setDateValue(e.target.value)}
          placeholder="Please input date(M/d/yyyy)"
        />
        <CalendarLtr20Regular className={styles.calendarIcon} />
      </div>
    </div>
  );
};
